<template>
  <div style="position: fixed; right: 63px; bottom: 30px;z-index: 100">
    <v-expand-transition>
      <v-card class="rounded rounded-b-0 backgroundworker px-1 pb-1" :elevation="4" width="290px"
        v-show="$store.getters.backgroundTaskCount > 0 && !$store.state.minimizedBackgroundWork">

        <v-list-item dense dark class="backgroundworker px-2" style="min-height: 30px;">
          <v-list-item-content class="d-flex align-center py-0" style="margin-left: 2px">
            <v-list-item-title>Background tasks</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="d-flex align-center ml-2">
            <v-btn text icon small @click="$store.dispatch('toggleBackgroundWork')">
              <v-icon size="20">$minus</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>

        <v-list dense class="py-0 my-0 rounded" color="backgroundworker lighten-3" dark min-height="25px"
          v-show="$store.getters.backgroundTaskCount">
          <v-slide-y-reverse-transition class="py-0" group>
            <template v-for="(item, i) in $store.state.NotificationStore.notifications">
              <v-divider v-show="i !== 0" :key="`${item.taskId}-divider`"></v-divider>
              <v-tooltip top :key="item.taskId">
                <template v-slot:activator="{ on }">
                  <v-list-item link class="px-2" @click="clickTask(item)">

                    <v-list-item-icon class="mr-1 ml-0 pl-0">
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content v-on="on">
                      <v-list-item-title>
                        <!-- <marquee scrolldelay="400" behavior="alternate"> -->
                        {{ item.displayText }}
                        <!-- </marquee> -->
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon class="d-flex align-center">
                      <!-- show either progress bar or a quick status icon -->
                      <v-icon v-if="item.status == 'created'" size="20" color="#C0C0C0">mdi-timer-sand</v-icon>
                      <template v-else-if="item.status == 'update'">
                        <v-hover v-slot="{ hover, props }">
                          <div v-bind="props">
                            <v-progress-circular v-if="!hover" size="16" :indeterminate="!item.progress"
                              :value="item.progress">
                            </v-progress-circular>
                            <v-btn v-else icon small><v-icon color="warning" @click="stopTask(item)">mdi-stop</v-icon></v-btn>
                          </div>
                        </v-hover>
                      </template>
                      <v-icon v-else-if="item.status == 'failed'">mdi-alert</v-icon>
                      <v-icon v-else-if="item.status == 'restart'">mdi-recycle</v-icon>
                      <v-icon v-else class="blink">mdi-check</v-icon>
                      <v-btn v-if="shouldRenderClose(item)" x-small v-on:click.prevent
                        style="min-width: 25px !important;" @click="closeTask(item)" class="mx-0 px-0">
                        <v-icon small>$close</v-icon>
                      </v-btn>
                    </v-list-item-icon>

                  </v-list-item>
                </template>
                <span>{{ item.displayText }}</span>
              </v-tooltip>
            </template>
          </v-slide-y-reverse-transition>
        </v-list>
      </v-card>
    </v-expand-transition>
  </div>
</template>


<script>
export default {
  name: "TaskList",
  methods: {
    stopTask(item) {
      this.$store.dispatch('NotificationStore/stopTask', item);
    },
    closeTask(item) {
      this.$store.dispatch('NotificationStore/closeTask', item);
    },
    clickTask(item) {
      //console.log("ClickTask", item)
      if (item.taskName == "TaskFailedEventArgs") {
        this.$store.dispatch('NotificationStore/restartTask', item)
      }
      else if (item.task.returnObject && item.task.returnObject.link) {
        window.location.href = item.task.returnObject.link
      }
    },
    shouldRenderClose(item) {
      return item?.task?.keepInNotificationBar == true
    }
  }
};
</script>


<style scoped lang="scss">
.list-leave-active {
  transition: all 0.5s;
  opacity: 0;
}

.blink {
  animation: blinktext 1s ease-in-out alternate-reverse infinite;

  @keyframes blinktext {
    from {
      color: var(--v-success-base);
    }

    to {
      color: unset;
    }
  }
}
</style>